<script>
    import EditVendor from "../components/EditVendor.svelte";
    import { modalAccept } from "../services/stores/modalAccept";
    import { alert } from "../services/stores/alert";
    import { _ } from "../services/i18n";
    import {
        deleteUser,
        getUsers,
        saveUser,
        updateUser,
    } from "../services/vendors";
    import { removeClient, clientStore } from "../services/session";
    import HeaderHome from "../components/HeaderHome.svelte";
    import HeaderCurrentClientInfo from "../components/HeaderCurrentClientInfo.svelte";
    import { settingsHeaderLinksStore } from "../services/header";

    let editVendor = false;
    let vendors = [];
    let activeModal = false,
        removeUserLogin;

    clientStore.subscribe(async (clientId) => {
        if (!clientId) {
            vendors = [];
            return;
        }
        const users = await getUsers(clientId);
        vendors = users.data.map((u) => ({
            name: u.data.name,
            phone: u.data.phone ?? "",
            email: u.data.email,
            password: u.password,
            login: u.login,
            acl: { orderConfirmation: u.acl?.orderConfirmation },
        }));
    });

    const removeUser = (userId) => {
        return async () => {
            const response = await deleteUser(userId);
            if (response.status !== true) {
                alert.newAlert({
                    type: "error",
                    message: $_("vendors.alert.errorDelete"),
                    timeOut: 5000,
                });
            }
            else {
                vendors = vendors.filter((n) => n.email !== userId);
                deleteRemoveUserMail();
                alert.newAlert({
                    type: "successful",
                    message: $_("vendors.alert.removed"),
                    timeOut: 5000,
                });
                location.reload();
            }
        };
    };

    const deleteRemoveUserMail = () => (removeUserLogin = undefined);

    const savedUser = async (e) => {
        if (modeEdit === "create") {
            await saveUser({ ...e.detail, roles: ["SALES"] });
            vendors.push({ ...e.detail, login: e.detail.email });
            alert.newAlert({
                type: "successful",
                message: $_("vendors.alert.saved"),
                timeOut: 5000,
            });
        } else {
            await updateUser({ login: editVendor.login, ...e.detail });
            const i = vendors.findIndex((v) => v.email === editVendor.email);
            vendors[i] = e.detail;
            alert.newAlert({
                type: "successful",
                message: $_("vendors.alert.updated"),
                timeOut: 5000,
            });
        }
        backToList();
    };

    const backToList = () => (editVendor = false);
    let modeEdit;
    const headerLinks = $settingsHeaderLinksStore;
</script>

<HeaderHome links={headerLinks} />
<HeaderCurrentClientInfo customText={$_("header.vendorCurrentClientText")} />

{#if editVendor}
    <EditVendor
        {editVendor}
        {modeEdit}
        on:save={savedUser}
        on:back={backToList}
    />
{:else}
    <main class="container">
        <table>
            <thead>
                <tr>
                    <th>{$_("vendors.table.login")}</th>
                    <th>{$_("vendors.table.name")}</th>
                    <th>{$_("vendors.table.phone")}</th>
                    <th>{$_("vendors.table.email")}</th>
                    <th>{$_("vendors.table.actions")}</th>
                </tr>
            </thead>
            <tbody>
                {#each vendors as vendor}
                    <tr>
                        <td>{vendor.login}</td>
                        <td>{vendor.name}</td>
                        <td>{vendor.phone ?? ""}</td>
                        <td>{vendor.email}</td>
                        <td>
                            <button
                                class="btn-3d second vendor"
                                on:click={() => {
                                    modeEdit = "edit";
                                    editVendor = { ...vendor };
                                }}
                            >
                                {$_("vendors.editUser.button")}
                                <img src="/icons/edit-sim3d.svg" alt="close" />
                            </button>
                            <button
                                class="btn-3d second vendor"
                                on:click={() =>
                                    modalAccept.newModal({
                                        message: $_("vendors.removeUser.body"),
                                        accept: removeUser(vendor.login),
                                    })}
                            >
                                {$_("vendors.removeUser.button")}
                                <img
                                    src="/icons/trash-sim3d-azul4.svg"
                                    alt="close"
                                />
                            </button>
                        </td>
                    </tr>
                {:else}
                    <tr>
                        <td colspan="100%">{$_("vendors.table.empty")}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
        <div class="buttons">
            <!-- <button id="new-client" class="btn-3d second" on:click={removeClient}>
        <img src="/icons/arrow-left-right.svg" alt="close" />
        {$_("vendors.changeClient")}
      </button> -->
            <button
                id="new-user"
                class="btn-3d second"
                on:click={() => {
                    modeEdit = "create";
                    editVendor = { acl: {} };
                }}
            >
                {$_("vendors.removeUser.add")}
            </button>
        </div>
    </main>
{/if}

<svelte:head>
    <link rel="stylesheet" href="styles/pages/vendors.css" />
</svelte:head>

<style>
    #new-user {
        width: 250px;
        margin-top: 15px;
        padding: 7px;
        text-transform: uppercase;
        background-color: var(--theme-color-1);
    }

    /* #new-client {
    width: 250px;
    margin-top: 15px;
    padding: 7px;
  }

  #new-client img {
    margin: 0 10px;
  } */

    .container {
        width: 1170px;
        margin: 0 auto;
    }

    table {
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
        border-collapse: collapse;
    }

    thead {
        font-size: 18px;
        color: var(--theme-color-3);
        line-height: 1.4;
        background-color: white;
        text-transform: uppercase;
        letter-spacing: 1.5px;
    }

    thead > * > th {
        padding: 18px 10px 18px 40px;
        font-weight: 400;
    }

    td {
        padding: 16px 10px 16px 40px;
        font-size: 15px;
        color: var(--theme-color-4);
        letter-spacing: 1.5px;
        font-weight: 300;
    }

    tbody > tr:nth-child(2n) {
        background-color: var(--gray-color);
    }

    th,
    td {
        text-align: center;
    }

    tbody tr {
        border-radius: 15px;
        padding: 10px;
        margin: 15px;
        background-color: #d8d8d833;
    }

    button img {
        height: 20px;
        margin-left: 10px;
    }

    .buttons {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        margin-top: 50px;
        font-weight: 300;
    }

    .vendor {
        display: inline-flex;
        align-items: center;
        align-content: center;
        padding: 7px;
    }

    .vendor img {
        height: 18px;
    }
    @media screen and (max-width: 1324px) {
        thead {
            font-size: 14px;
        }

        td {
            padding: 0px;
            font-size: 14px;
        }

        .vendor {
            height: 26px;
            margin: 5px;
        }
    }

    @media screen and (max-width: 768px) and (min-width: 0px) {
        .container {
            width: 100%;
            margin: 0 auto;
        }

        thead > * > th {
            padding: 0px;
            font-weight: 400;
            font-size: 12px;
        }

        tbody tr {
            padding: 0px;
            margin: 0px;
        }

        td {
            padding: 0px;
            font-size: 12px;
        }

        button {
            width: 35%;
            font-size: 0px;
            padding: 5px;
        }

        button img {
            height: 14px !important;
            position: relative;
            margin-left: 0;
        }

        #new-user {
            width: 40%;
            margin-top: 0px;
            padding: 7px;
            font-size: 12px;
        }

        /* #new-client {
      width: 40%;
      margin-top: 0px;
      padding: 7px;
      font-size: 12px;
    }

    #new-client img {
      display: none;
    } */

        .vendor {
            margin: 5px 0;
            justify-content: flex-end;
        }
    }
</style>
